import axios from 'axios';
import { getFeatureFlagsDebounced } from './../app/common/requets/getFeatureFlags';
import { userHotelDetails } from './handleBrandAndHotelData';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const { userData, selectedClient } = userHotelDetails();
    if (userData) {
      const accessToken = userData.accessToken;
      if (!config.params) {
        config.params = {};
      }

      delete config.params.selectedClientId;
      if (selectedClient) {
        config.params.selectedClientId = selectedClient;
      }

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {

    const ffExpired = response.headers['x-ff-expired'];

    if (ffExpired && ffExpired === 'true') {
      // Use debounced version to prevent multiple rapid calls
      getFeatureFlagsDebounced(true); // Force refresh when expired
    }
    return response;
  },
  (error) => {
    console.error('Response Error Interceptor:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
